import { AuthenticatedToken } from '@dtos/AuthenticatedToken';
import { IErrorReportingService } from '@services/error-reporting-service';
import { IRemoteRepresentativeService } from '@services/remote-representative-service';
import { IAuthorisationStore } from '@stores/authorisation/authorisation-store';
import jwtDecode from 'jwt-decode';

export interface IAuthenticatedUserService {
    setupErrorReporting(authorisedRepresentativeId: string): Promise<void>;
}

class AuthenticatedUserService implements IAuthenticatedUserService {
    static errorReportingContext = {
        tags: {
            service: 'AuthenticatedUserService'
        }
    };

    constructor(
        readonly remoteRepresentativeService: IRemoteRepresentativeService,
        readonly authorisationStore: IAuthorisationStore,
        readonly errorReportingService: IErrorReportingService
    ) {}

    async setupErrorReporting(
        authorisedRepresentativeId: string
    ): Promise<void> {
        try {
            if (!authorisedRepresentativeId) {
                this.errorReportingService.reportError(
                    new Error(
                        'Cannot setup user: Authorised Representative Id is invalid'
                    ),
                    AuthenticatedUserService.errorReportingContext
                );
            }

            const { authorisationToken, isTokenValid } =
                this.authorisationStore;
            if (!isTokenValid || !authorisationToken) {
                this.errorReportingService.reportError(
                    new Error('Cannot setup user: Token is invalid'),
                    AuthenticatedUserService.errorReportingContext
                );
                return;
            }

            const { emailAddress } =
                jwtDecode<AuthenticatedToken>(authorisationToken);

            this.errorReportingService.setUser(
                authorisedRepresentativeId,
                emailAddress
            );
        } catch (error) {
            this.errorReportingService.reportError(
                error,
                AuthenticatedUserService.errorReportingContext
            );
        }
    }
}

export default AuthenticatedUserService;



// WEBPACK FOOTER //
// ./src/services/authenticated-user-service.ts